import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { Avatar, CardHeader, Grid } from "@material-ui/core";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import Skeleton from "@material-ui/lab/Skeleton";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import ArtTrackIcon from '@material-ui/icons/ArtTrack';
function ProximoTurno({ turno }) {
  return (
    <Card style={{ height: 300 }}>
      {!turno ? (
        <Box m={5}>
          <Skeleton animation={false} />
        </Box>
      ) : (
        <CardHeader title={turno.fechaHora} subheader={null} />)}
      < CardContent >
      <Grid container>
        <Grid item md={12}>
          {!turno ? (
            <>
              <Skeleton animation={false} />
              <Skeleton animation={false} />
              <Skeleton animation={false} />
            </>
          ) : (
            <List>
              <ListItem>
                <ListItemIcon>
                  <AccountCircleIcon />
                </ListItemIcon>
                <ListItemText primary={turno.solicitante} />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <ArtTrackIcon />
                </ListItemIcon>
                <ListItemText primary={turno.dni} />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <LocalHospitalIcon />
                </ListItemIcon>
                <ListItemText primary={turno.servidor} />
              </ListItem>
            </List>
          )}
        </Grid>
      </Grid>
      </CardContent>
    </Card >
  );
}

export default ProximoTurno;
